var Shopify = Shopify || {};
const product = JSON.parse(document.querySelector('[data-product-id]').textContent);
const amount_with_comma_separator = '{{amount_with_comma_separator}}';
const variants = document.querySelectorAll('[data-variant]');
const optionsSize = parseInt(document.querySelector('[data-options-size]').getAttribute('data-options-size'));
const quantityInput = document.querySelector('.quantity-input');
const incrementButton = document.querySelector('.increment-button');
const decrementButton = document.querySelector('.decrement-button');
const crossselling = document.querySelectorAll('.crossselling-product');
const addToCartForm = document.querySelector('form[id="add-to-cart"]');
const stickyAddToCartForm = document.querySelector('form[id="sticky-add-to-cart"]');
const stocks = document.querySelectorAll('input[name="variant-stock"]');
const imageWrapper = document.querySelectorAll('.mySwiper2 .swiper-wrapper .swiper-slide');
const variantError = document.querySelector('.variant-error');
const stickyVariantError = document.querySelector('.sticky-variant-error');
const stocksMap = {};
var currentOptions = {};

stocks.forEach((stock) => {
  const variantId = stock.value;
  const stockValue = parseInt(stock.getAttribute('data-stock'));
  stocksMap[variantId] = stockValue;
});

// Add to cart
if (addToCartForm) {
  addToCartForm.addEventListener('submit', function (event) {
    event.preventDefault();
    handleAddToCart(event, addToCartForm, variantError);
  });
}

if (stickyAddToCartForm) {
  stickyAddToCartForm.addEventListener('submit', function (event) {
    event.preventDefault();
    handleAddToCart(event, stickyAddToCartForm, stickyVariantError);
  });
}

// Variants
if (variants) {
  // First init of the variants
  //initializeVariants();

  // Get the on click or on change state of the variant
  variants.forEach((variant) => {
    ['click', 'change'].forEach((event) => {
      variant.addEventListener(event, () => handleVariantChange(variant));
    });
  });
}

// Crossselling
if (crossselling) {
  crossselling.forEach(function (product) {
    handleCrosssellingChange(product);
  });

  // Initialize cross-sell sync for static cross-sells
  setTimeout(() => {
    if (window.crosssellQuantitySync) {
      window.crosssellQuantitySync.refreshCrosssellProducts();
    }
  }, 100);
}

setTimeout(() => {
  document.querySelectorAll('[data-volume-quantity]').forEach((e) => {
    e.addEventListener('click', function () {
      if (!quantityInput) return;
      const volume_quantity = e.getAttribute('data-volume-quantity');
      const volume_price = e.getAttribute('data-discounted-price');
      const volume_current_price = document.querySelector('.current-price');
      volume_current_price.setAttribute('data-price', volume_price);
      quantityInput.value = parseInt(volume_quantity);

      if (currentOptions) {
        updateCurrentOptions(currentOptions, false);
      }

      // Trigger cross-sell quantity sync (debounced)
      if (window.crosssellQuantitySync) {
        setTimeout(() => {
          window.crosssellQuantitySync.manualSync();
        }, 50);
      }
    });
  });
}, 2000);

function initializeVariants() {
  const optionNames = ['option1', 'option2', 'option3'];

  // Select the first options
  optionNames.forEach((optionName) => {
    var option = document.querySelector(`[name="${optionName}"]`);
    if (option) {
      if (option.tagName == 'INPUT') {
        var optionValue = document.querySelector(`[name="${optionName}"]`).getAttribute('data-value');
        var parent = option.parentElement;
        if (!parent.classList.contains('variant-active')) {
          parent.classList.add('variant-active');
          currentOptions[optionName] = optionValue;
        }
      }
      if (option.tagName == 'SELECT') {
        var optionValue = option.options[1].getAttribute('data-value');
        option.options[1].selected = true;
        currentOptions[optionName] = optionValue;
      }
    }
  });

  // Update the current stock and price
  if (currentOptions) {
    updateCurrentOptions(currentOptions);
  }
}

function setQuantityControlsEnabled(enabled) {
  // Enable/disable main product quantity controls
  document.querySelectorAll('.quantity-input, .increment-button, .decrement-button').forEach((el) => {
    el.disabled = !enabled;
    // Remove any disabled attribute that might have been set by Liquid
    if (enabled) {
      el.removeAttribute('disabled');
    }
  });

  // Enable/disable cross-selling quantity controls (they have unique IDs)
  document
    .querySelectorAll('[id^="quantity-input-"], [id^="increment-button-"], [id^="decrement-button-"]')
    .forEach((el) => {
      el.disabled = !enabled;
      // Remove any disabled attribute that might have been set by Liquid
      if (enabled) {
        el.removeAttribute('disabled');
      }
    });
}

// Call this on initial load based on the first available variant
if (typeof product !== 'undefined' && product.variants) {
  const firstVariant = product.variants.find((v) => v.id == product.selected_or_first_available_variant?.id);
  setQuantityControlsEnabled(firstVariant && firstVariant.available);

  // Auto-select the first available variant to prevent customer confusion
  autoSelectFirstAvailableVariant();
}

// Function to automatically select the first available variant
function autoSelectFirstAvailableVariant() {
  // Find the first available variant
  const firstAvailableVariant = product.variants.find((variant) => variant.available);

  if (!firstAvailableVariant) {
    console.log('No available variants found');
    return;
  }

  // Set current options based on the first available variant
  currentOptions = {
    option1: firstAvailableVariant.option1 || 'Default Title',
    option2: firstAvailableVariant.option2 || '',
    option3: firstAvailableVariant.option3 || '',
  };

  // Update all variant inputs/selects to reflect the first available variant
  const optionNames = ['option1', 'option2', 'option3'];

  optionNames.forEach((optionName, index) => {
    const optionValue = currentOptions[optionName];
    if (!optionValue) return;

    // Handle radio button inputs
    const radioInputs = document.querySelectorAll(`input[name="${optionName}"]`);
    radioInputs.forEach((input) => {
      if (input.getAttribute('data-value') === optionValue) {
        input.checked = true;
        // Add active class to the parent label
        const label = input.parentElement;
        if (label) {
          label.classList.add('variant-active');
        }
      } else {
        input.checked = false;
        // Remove active class from other labels
        const label = input.parentElement;
        if (label) {
          label.classList.remove('variant-active');
        }
      }
    });

    // Handle select dropdowns
    const selectElement = document.querySelector(`select[name="${optionName}"]`);
    if (selectElement) {
      const options = selectElement.options;
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        if (option.getAttribute('data-value') === optionValue) {
          selectElement.selectedIndex = i;
          break;
        }
      }
    }
  });

  // Update prices and stock based on the selected variant
  updateCurrentOptions(currentOptions);

  // Enable quantity controls for the selected variant
  setQuantityControlsEnabled(firstAvailableVariant.available);

  // Update cross-selling if variant-specific is enabled
  const variantCrosssellingData = document.querySelector('#variant-crossselling-data');
  if (variantCrosssellingData) {
    updateCrosssellingForVariant();
  }

  console.log('Auto-selected first available variant:', firstAvailableVariant);
}

function handleVariantChange(variant) {
  // First get the option name
  const optionName = variant.getAttribute('data-name');

  // Second get the option value based on the type
  if (variant.tagName == 'SELECT') {
    const selectedOption = variant.options[variant.selectedIndex];
    var optionValue = selectedOption.getAttribute('data-value');
  } else {
    var optionValue = variant.getAttribute('data-value');
  }

  // Check if optionValue is not null and if the value has actually changed
  if (optionValue !== null && currentOptions[optionName] !== optionValue) {
    // Create object with the values
    currentOptions[optionName] = optionValue;

    // Create active state on the click elements (only on inputs)
    if (variant.tagName == 'INPUT') {
      var allInputs = document.querySelectorAll(`[name="${optionName}"]`);
      var input = document.querySelector(`[name="${optionName}"][data-value="${currentOptions[optionName]}"]`);
      var label = input.parentElement;

      // Remove all class actives from the currently clicked labels
      allInputs.forEach((item) => {
        var parentItem = item.parentElement;
        parentItem.classList.remove('variant-active');
      });

      // Add class active to the clicked label
      label.classList.add('variant-active');
    }

    // Update the current stock and price
    if (currentOptions) {
      updateCurrentOptions(currentOptions);
    }

    // Update cross-selling items based on selected variant (only if variant-specific is enabled)
    const variantCrosssellingData = document.querySelector('#variant-crossselling-data');
    if (variantCrosssellingData) {
      updateCrosssellingForVariant();
    }

    // Enable/disable quantity controls based on selected variant
    const selectedVariant = product.variants.find(
      (v) =>
        (!v.option1 || v.option1 === currentOptions.option1) &&
        (!v.option2 || v.option2 === currentOptions.option2) &&
        (!v.option3 || v.option3 === currentOptions.option3)
    );
    setQuantityControlsEnabled(selectedVariant && selectedVariant.available);
  }
}

// Function to update cross-selling items based on selected variant
function updateCrosssellingForVariant() {
  const crosssellingContainer = document.querySelector('#crossselling-container');
  const crosssellingItemsContainer = document.querySelector('#crossselling-items');
  const variantCrosssellingData = document.querySelector('#variant-crossselling-data');

  if (!crosssellingContainer || !crosssellingItemsContainer || !variantCrosssellingData) {
    return;
  }

  // Get the currently selected variant
  let selectedVariantId = null;

  // First try to get from currentOptions (when user has selected options)
  if (currentOptions && Object.keys(currentOptions).length > 0) {
    var option1 = currentOptions['option1'] || 'Default Title';
    var option2 = currentOptions['option2'] || '';
    var option3 = currentOptions['option3'] || '';
    var found = null;

    switch (optionsSize) {
      case 3:
        found = product.variants.find((v) => v.option1 === option1 && v.option2 === option2 && v.option3 == option3);
        break;
      case 2:
        found = product.variants.find((v) => v.option1 === option1 && v.option2 === option2);
        break;
      case 1:
        found = product.variants.find((v) => v.option1 === option1);
        break;
    }
    if (found) selectedVariantId = found.id;
  }

  // If still null, use the first available variant
  if (!selectedVariantId && typeof product.selected_or_first_available_variant !== 'undefined') {
    selectedVariantId = product.selected_or_first_available_variant.id;
  }

  // If still null, use the first variant
  if (!selectedVariantId && product.variants && product.variants.length > 0) {
    selectedVariantId = product.variants[0].id;
  }

  if (!selectedVariantId) {
    return;
  }

  // Find the cross-selling data for this variant
  const variantData = variantCrosssellingData.querySelector(`[data-variant-id="${selectedVariantId}"]`);

  if (!variantData) {
    // No dynamic cross-selling items for this variant, show the standard cross-selling
    crosssellingContainer.style.display = 'block';
    return;
  }

  // Show the container
  crosssellingContainer.style.display = 'block';

  // Add loading state
  crosssellingContainer.classList.add('loading');

  try {
    // Get the cross-selling items data from individual data attributes
    const crosssellingItemElements = variantData.querySelectorAll('[data-crossselling-item]');
    console.log('Cross-selling item elements found:', crosssellingItemElements.length);

    if (!crosssellingItemElements || crosssellingItemElements.length === 0) {
      console.log('No dynamic cross-selling items found, showing standard cross-selling');
      crosssellingContainer.style.display = 'block';
      return;
    }

    // Convert DOM elements to data objects
    const itemsArray = Array.from(crosssellingItemElements).map((element) => ({
      title: element.getAttribute('data-title'),
      price: parseInt(element.getAttribute('data-price')),
      compare_at_price: parseInt(element.getAttribute('data-compare-price')),
      variants: [
        {
          id: element.getAttribute('data-variant-id'),
          inventory_quantity: parseInt(element.getAttribute('data-inventory')),
        },
      ],
      featured_image: element.getAttribute('data-image'),
      metafields: {
        custom: {
          korte_omschrijving: element.getAttribute('data-description'),
        },
      },
    }));

    console.log('Items array to process:', itemsArray);

    // Generate HTML for the cross-selling items
    let html = '';
    itemsArray.forEach((item, index) => {
      console.log('Processing item:', item);
      const isOutOfStock = item.variants && item.variants[0] && item.variants[0].inventory_quantity === 0;
      const outOfStockClass = isOutOfStock ? 'opacity-50 pointer-events-none' : '';
      const outOfStockOverlay = isOutOfStock
        ? '<div class="absolute inset-0 bg-gray-400 bg-opacity-60 z-10 rounded-md"></div>'
        : '';
      const outOfStockLabel = isOutOfStock
        ? '<span class="absolute right-2 md:right-auto md:left-32 top-2 bg-gray-700 text-white text-[10px] px-1.5 py-0.5 rounded z-20">Uitverkocht</span>'
        : '';

      const imageHtml = item.featured_image
        ? `<img src="${item.featured_image}" alt="${item.title}" width="500" height="500" class="w-28 h-full object-cover rounded-l-md mr-4 shrink-0">`
        : '';

      const comparePriceHtml =
        item.compare_at_price > item.price
          ? `<span class="line-through text-[#0C2B38] opacity-50 text-sm">${Shopify.formatMoney(
              item.compare_at_price,
              amount_with_comma_separator
            )}</span>`
          : '';

      const infoIconHtml =
        item.metafields && item.metafields.custom && item.metafields.custom.korte_omschrijving
          ? `<div class="pb-[2.5px] shrink-0">
          <img src="${
            window.emInfoIconUrl || '/assets/em-info.svg'
          }" alt="info" class="w-4 h-auto cursor-pointer popup-trigger" width="16" height="16" data-popup="crosssell-popup-${
              index + 1
            }">
          <div
            id="crosssell-popup-${index + 1}"
            class="popup-content fixed inset-0 bg-black/50 z-[10000] hidden"
          >
            <div class="absolute flex flex-col items-start top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-soft p-10 rounded-[3px] w-full max-w-[340px] sm:max-w-lg">
              <button class="popup-close absolute top-3 flex right-3 w-10 h-10 items-center justify-center shrink-0">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div class="flex gap-6">
                ${
                  item.featured_image
                    ? `
                  <img
                    src="${item.featured_image}"
                    alt="${item.title}"
                    width="500"
                    height="500"
                    class="w-44 h-auto object-contain aspect-square rounded-[3px]"
                  >
                `
                    : ''
                }
                <div class="flex flex-col gap-2">
                  <h3 class="text-lg font-black text-highlight_dark">${item.title}</h3>
                  <div class="prose">
                    ${item.metafields.custom.korte_omschrijving}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`
          : '';

      html += `
        <div class="flex items-start gap-4${
          index < itemsArray.length - 1 ? ' mb-2' : ''
        } crossselling-product relative ${outOfStockClass}" 
             id="crossselling-${index + 1}" data-variant-id="${item.variants ? item.variants[0].id : ''}">
          ${outOfStockOverlay}
          ${outOfStockLabel}
          <div class="flex justify-between gap-4 w-full bg-transparent border border-[#E8E8E8] flex-grow rounded-md pr-4 md:pr-7">
            <div class="flex items-center w-24 h-auto md:w-auto">
              ${imageHtml}
              <div class="flex flex-col gap-2 py-7">
                <div class="gap-2 items-center hidden md:flex">
                  <span class="text-base font-bold">${item.title}</span>
                  ${infoIconHtml}
                </div>
                <div class="gap-2 items-center hidden md:flex">
                  <label class="relative inline-block w-11 h-6 cursor-pointer">
                    <input type="checkbox" class="peer sr-only">
                    <div class="w-11 h-6 bg-[#E8E8E8] rounded-full transition-colors duration-300 peer-checked:bg-accent !block shadow-toggle"></div>
                    <span class="absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transition-all duration-300 peer-checked:translate-x-5"></span>
                  </label>
                  <p class="crosssell-toggle-text">Toegevoegd</p>
                </div>
              </div>
            </div>
            <div class="flex items-start md:items-center justify-center w-full flex-col md:flex-row md:w-auto py-4 md:py-0">
              <div class="flex gap-2 items-center md:hidden w-full md:w-auto mb-2 md:mb-0">
                <span class="text-base font-bold">${item.title}</span>
                ${infoIconHtml}
              </div>
              <div class="flex justify-between items-center gap-3 w-full md:w-auto shrink-0">
                <div class="flex flex-col items-start md:items-end">
                  ${comparePriceHtml}
                  <div class="flex gap-2 whitespace-nowrap">
                    <p class="flex items-center">
                      ${Shopify.formatMoney(item.price, amount_with_comma_separator)}
                      <span class="ml-1">per stuk</span>
                    </p>
                    <div class="text-sm gap-2 items-center font-bold hidden" data-product-price="${
                      item.price
                    }" data-excl-price="${item.price}">
                      <p>${Shopify.formatMoney(item.price, amount_with_comma_separator)}</p>
                    </div>
                  </div>
                </div>
                <form>
                  <div class="relative flex items-center border border-[#E8E8E8] rounded-md">
                    <input type="text" id="quantity-input-${index + 1}" aria-describedby="helper-text-explanation" 
                           class="bg-white pointer-events-none border-none text-center text-sm w-12 py-2.5 placeholder:!text-black placeholder:!text-base rounded-l-md" 
                           placeholder="0" required readonly>
                    <div class="flex flex-col">
                      <button type="button" id="increment-button-${
                        index + 1
                      }" data-input-counter-decrement="quantity-input-${index + 1}" class="py-1 px-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="none" class="w-2.5 h-auto">
                          <path d="M0.485726 3.85338C0.579632 3.94726 0.706979 4 0.839762 4C0.972545 4 1.09989 3.94726 1.1938 3.85338L3.67255 1.37463L6.1513 3.85338C6.24575 3.9446 6.37224 3.99508 6.50354 3.99393C6.63483 3.99279 6.76043 3.94013 6.85327 3.84728C6.94612 3.75444 6.99878 3.62884 6.99992 3.49755C7.00106 3.36625 6.95059 3.23976 6.85937 3.14531L4.02659 0.312526C3.93268 0.218648 3.80533 0.165911 3.67255 0.165911C3.53977 0.165911 3.41242 0.218648 3.31851 0.312526L0.485726 3.14531C0.391849 3.23922 0.339111 3.36657 0.339111 3.49935C0.339111 3.63213 0.391849 3.75948 0.485726 3.85338Z" fill="#082028"/>
                        </svg>
                      </button>
                      <button type="button" id="decrement-button-${
                        index + 1
                      }" data-input-counter-increment="quantity-input-${index + 1}" class="py-1 px-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="none" class="w-2.5 h-auto">
                          <path d="M0.485726 0.146615C0.579632 0.0527376 0.706979 0 0.839762 0C0.972545 0 1.09989 0.0527376 1.1938 0.146615L3.67255 2.62537L6.1513 0.146615C6.24575 0.0553981 6.37224 0.00492431 6.50354 0.00606525C6.63483 0.00720619 6.76043 0.0598705 6.85327 0.152715C6.94612 0.24556 6.99878 0.371156 6.99992 0.502453C7.00106 0.63375 6.95059 0.760243 6.85937 0.854687L4.02659 3.68747C3.93268 3.78135 3.80533 3.83409 3.67255 3.83409C3.53977 3.83409 3.41242 3.78135 3.31851 3.68747L0.485726 0.854687C0.391849 0.760781 0.339111 0.633434 0.339111 0.500651C0.339111 0.367868 0.391849 0.240521 0.485726 0.146615Z" fill="#082028"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      `;
    });

    console.log('Generated HTML length:', html.length);
    console.log('Generated HTML preview:', html.substring(0, 200) + '...');

    // Update the cross-selling items container
    crosssellingItemsContainer.innerHTML = html;

    // Re-initialize cross-selling functionality for new items
    setTimeout(() => {
      const newCrossselling = document.querySelectorAll('.crossselling-product');
      console.log('New cross-selling items found:', newCrossselling.length);
      newCrossselling.forEach(function (product) {
        handleCrosssellingChange(product);
      });

      // Re-initialize popup functionality for dynamically added content
      const newPopupTriggers = crosssellingItemsContainer.querySelectorAll('.popup-trigger');
      const newCloseButtons = crosssellingItemsContainer.querySelectorAll('.popup-close');

      console.log('Re-initializing popup functionality:', {
        triggers: newPopupTriggers.length,
        closeButtons: newCloseButtons.length,
      });

      // Add click event listeners to new popup triggers
      newPopupTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          const popupId = this.dataset.popup;
          const popup = document.getElementById(popupId);
          if (popup) {
            popup.classList.remove('hidden');
          } else {
            console.error('Popup element not found with ID:', popupId);
          }
        });
      });

      // Add click event listeners to new close buttons
      newCloseButtons.forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          const popup = this.closest('.popup-content');
          if (popup) {
            popup.classList.add('hidden');
          }
        });
      });

      // Add overlay click functionality to new popup content elements
      const newPopupContents = crosssellingItemsContainer.querySelectorAll('.popup-content');
      newPopupContents.forEach(function (popupContent) {
        popupContent.addEventListener('click', function (e) {
          // Close popup when clicking on the overlay (not on the content inside)
          if (e.target === popupContent) {
            popupContent.classList.add('hidden');
          }
        });
      });

      // Trigger cross-sell quantity sync after re-initialization
      if (window.crosssellQuantitySync) {
        window.crosssellQuantitySync.refreshCrosssellProducts();
      }
    }, 100);
  } catch (error) {
    console.error('Error updating cross-selling items:', error);
  } finally {
    // Remove loading state
    crosssellingContainer.classList.remove('loading');
  }
}

function handleCrosssellingChange(product) {
  const incrementButton = product.querySelector('[id^="increment-button"]');
  const decrementButton = product.querySelector('[id^="decrement-button"]');
  const quantityInput = product.querySelector('[id^="quantity-input"]');
  const productPriceElement = product.querySelector('[data-product-price]');
  const checkbox = product.querySelector('input[type="checkbox"]');
  const toggleText = product.querySelector('.crosssell-toggle-text');
  let basePrice = parseFloat(productPriceElement.getAttribute('data-product-price')) / 100;
  let basePriceExcl = parseFloat(productPriceElement.getAttribute('data-product-price')) / 100;
  let quantity = 0;
  let totalPrice = basePrice;

  // Add debouncing and state management for rapid clicks
  let isUpdating = false;
  let updateTimeout = null;

  function updateQuantityAndPrice() {
    // Prevent multiple simultaneous updates
    if (isUpdating) {
      console.log('Quantity update already in progress, skipping...');
      return;
    }

    isUpdating = true;

    // Clear any pending updates
    if (updateTimeout) {
      clearTimeout(updateTimeout);
    }

    // Debounce the update
    updateTimeout = setTimeout(() => {
      try {
        // Ensure quantity is a valid number
        quantity = Math.max(0, parseInt(quantity) || 0);
        quantityInput.value = quantity;
        decrementButton.disabled = quantity === 0;
        if (checkbox) checkbox.checked = quantity > 0;
        if (toggleText) toggleText.textContent = quantity > 0 ? 'Toegevoegd' : 'Niet toegevoegd';
        productPriceElement.setAttribute('data-excl-price', basePriceExcl * quantity * 100);
        productPriceElement.innerHTML = `${(basePrice * quantity).toFixed(2).replace('.', ',')}`;

        // Debounce the price update call
        setTimeout(() => {
          if (window.updatePriceWithCrossselling) {
            window.updatePriceWithCrossselling();
          }
        }, 50);

        console.log('Cross-sell quantity updated:', { variantId: product.getAttribute('data-variant-id'), quantity });
      } finally {
        isUpdating = false;
      }
    }, 50); // 50ms debounce
  }

  incrementButton.addEventListener('click', (e) => {
    console.log('Cross-sell increment button clicked', {
      target: e.target,
      currentTarget: e.currentTarget,
      bubbles: e.bubbles,
    });
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling
    if (!isUpdating) {
      quantity += 1;
      updateQuantityAndPrice();
    }
  });

  decrementButton.addEventListener('click', (e) => {
    console.log('Cross-sell decrement button clicked', {
      target: e.target,
      currentTarget: e.currentTarget,
      bubbles: e.bubbles,
    });
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling
    if (!isUpdating && quantity > 0) {
      quantity -= 1;
      updateQuantityAndPrice();
    }
  });

  if (checkbox) {
    checkbox.addEventListener('change', function (e) {
      console.log('Cross-sell checkbox changed', {
        target: e.target,
        currentTarget: e.currentTarget,
        bubbles: e.bubbles,
        checked: checkbox.checked,
      });
      e.preventDefault();
      e.stopPropagation(); // Prevent event bubbling
      if (!isUpdating) {
        if (checkbox.checked) {
          quantity = 1;
        } else {
          quantity = 0;
        }
        updateQuantityAndPrice();
      }
    });
    // Set initial state
    checkbox.checked = quantity > 0;
    if (toggleText) toggleText.textContent = quantity > 0 ? 'Toegevoegd' : 'Niet toegevoegd';
  }

  // Add direct input change listener for manual quantity entry with debouncing
  if (quantityInput) {
    let inputTimeout = null;
    quantityInput.addEventListener('input', function (e) {
      console.log('Cross-sell input changed', {
        target: e.target,
        currentTarget: e.currentTarget,
        bubbles: e.bubbles,
        value: this.value,
      });
      e.preventDefault();
      e.stopPropagation(); // Prevent event bubbling

      // Clear any pending input updates
      if (inputTimeout) {
        clearTimeout(inputTimeout);
      }

      // Debounce input changes
      inputTimeout = setTimeout(() => {
        if (!isUpdating) {
          const inputValue = parseInt(this.value) || 0;
          quantity = Math.max(0, inputValue);
          updateQuantityAndPrice();
        }
      }, 100); // 100ms debounce for manual input
    });
  }

  updateQuantityAndPrice();
}

function updateCurrentOptions(currentOptions, updateImage = true) {
  var option1 = currentOptions['option1'] || 'Default Title';
  var option2 = currentOptions['option2'] || '';
  var option3 = currentOptions['option3'] || '';

  // Check how many variants are available
  switch (optionsSize) {
    case 3:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2 && variant.option3 == option3
      );
      break;
    case 2:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2
      );
      break;
    case 1:
      var currentOption = product.variants.filter((variant) => variant.option1 === option1);
      break;
  }

  if (currentOption[0] !== undefined) {
    var id = currentOption[0].id;
    var price = currentOption[0].price;
    var compare_at_price = currentOption[0].compare_at_price;
    var stock = stocksMap[id] || 0;
    var barcode = currentOption[0].barcode;

    updatePriceWithStock(price, compare_at_price, stock, id, updateImage);

    updateBarcode(barcode);
  } else {
    // Update discounts is available
    updatePriceWithDiscounts();
  }
}

function updatePriceWithDiscounts() {
  const volumeDiscountContainer = document.querySelector('#volume-discount-container');
  const currentPrice = document.querySelector('.current-price');
  const quantity = parseInt(quantityInput?.value || 1);

  if (volumeDiscountContainer) {
    var volumeDiscountSlots = document.querySelectorAll('#volume-discount-container [data-volume-quantity]');
    volumeDiscountSlots.forEach((el) => {
      var dataVolumeQty = parseInt(el.dataset.volumeQuantity);
      var dataDiscountedPrice = el.dataset.discountedPrice;
      if (quantity >= dataVolumeQty) {
        discountedPriceExcl = parseFloat(quantity * dataDiscountedPrice);
      }
    });
  }

  const prettyDiscountedPrice = Shopify.formatMoney(discountedPriceExcl, amount_with_comma_separator);

  if (currentPrice) {
    if (discountedPriceExcl > 0) {
      currentPrice.innerHTML = `${prettyDiscountedPrice}`;
    }
  }
}

function updatePriceWithStock(price, compare_at_price, stock, id, updateImage = true) {
  // Volume discount check
  const volumeDiscountContainer = document.querySelector('#volume-discount-container');
  var priceExcl = price;
  var comparePriceExcl = compare_at_price;
  var discountedPriceExcl = 0;

  if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
    var price = price * 1.21;
    var compare_at_price = compare_at_price * 1.21;
  }

  // Update for the price
  const currentPrice = document.querySelector('.current-price');
  const currentComparePrice = document.querySelector('.compare-at-price');
  const quantity = parseInt(quantityInput?.value || 1);
  var totalPrice = price * quantity;
  var totalPriceExcl = priceExcl * quantity;
  var totalComparePrice = compare_at_price * quantity;
  var totalComparePriceExcl = comparePriceExcl * quantity;

  // Add cross-selling items (use a Set to prevent duplicates)
  const processedVariants = new Set();

  // Add static cross-selling items
  if (crossselling) {
    crossselling.forEach(function (product) {
      const variantId = product.getAttribute('data-variant-id');
      const checkbox = product.querySelector('input[type="checkbox"]');
      const crosssellingQuantityInput = product.querySelector('[id^="quantity-input"]');

      //if (checkbox && checkbox.checked && crosssellingQuantityInput) {
      if (crosssellingQuantityInput && !processedVariants.has(variantId)) {
        processedVariants.add(variantId);
        const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 0);
        const crosssellingPrice = parseFloat(
          product.querySelector('[data-product-price]').getAttribute('data-product-price')
        );
        if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
          totalPrice += crosssellingPrice * 1.21 * crosssellingQuantity;
          totalComparePrice += crosssellingPrice * 1.21 * crosssellingQuantity;
        } else {
          totalPrice += crosssellingPrice * crosssellingQuantity;
          totalComparePrice += crosssellingPrice * crosssellingQuantity;
        }
        totalPriceExcl += crosssellingPrice * crosssellingQuantity;
      }
    });
  }

  // Add dynamic cross-selling items (variant-specific)
  const dynamicCrosssellingItems = document.querySelectorAll('.crossselling-product');
  dynamicCrosssellingItems.forEach(function (product) {
    const variantId = product.getAttribute('data-variant-id');
    const crosssellingQuantityInput = product.querySelector('[id^="quantity-input"]');

    if (crosssellingQuantityInput && !processedVariants.has(variantId)) {
      processedVariants.add(variantId);
      const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 0);
      const crosssellingPrice = parseFloat(
        product.querySelector('[data-product-price]').getAttribute('data-product-price')
      );
      if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
        totalPrice += crosssellingPrice * 1.21 * crosssellingQuantity;
        totalComparePrice += crosssellingPrice * 1.21 * crosssellingQuantity;
      } else {
        totalPrice += crosssellingPrice * crosssellingQuantity;
        totalComparePrice += crosssellingPrice * crosssellingQuantity;
      }
      totalPriceExcl += crosssellingPrice * crosssellingQuantity;
    }
  });

  if (volumeDiscountContainer) {
    var volumeDiscountSlots = document.querySelectorAll('#volume-discount-container [data-volume-quantity]');
    volumeDiscountSlots.forEach((el) => {
      var dataVolumeQty = parseInt(el.dataset.volumeQuantity);
      var dataDiscountedPrice = el.dataset.discountedPrice;
      if (quantity >= dataVolumeQty) {
        discountedPriceExcl = parseFloat(quantity * dataDiscountedPrice);
      }
    });
  }

  const prettyPrice = Shopify.formatMoney(totalPrice, amount_with_comma_separator);
  const prettyComparePrice = Shopify.formatMoney(totalComparePrice, amount_with_comma_separator);
  const prettyDiscountedPrice = Shopify.formatMoney(discountedPriceExcl, amount_with_comma_separator);

  if (currentPrice) {
    currentPrice.setAttribute('data-solo-price', price);
    currentPrice.setAttribute('data-price', priceExcl);
    currentPrice.setAttribute('data-stock', stock);
    currentPrice.setAttribute('data-excl-price', totalPriceExcl);
    if (currentComparePrice) {
      currentComparePrice.setAttribute('data-excl-price', totalComparePriceExcl);
    }

    // This statements checks the bundler app
    if (!volumeDiscountContainer) {
      currentPrice.innerHTML = `${prettyPrice}`;
    } else {
      if (discountedPriceExcl > 0) {
        currentPrice.innerHTML = `${prettyDiscountedPrice}`;
      } else {
        currentPrice.innerHTML = `${prettyPrice}`;
      }
    }
  }

  if (currentComparePrice) {
    currentComparePrice.setAttribute('data-compare-price', compare_at_price);
    // This statements checks the bundler app
    if (!volumeDiscountContainer) {
      currentComparePrice.innerHTML = `${prettyComparePrice}`;
    } else {
      //if (!volumeDiscountContainer.children.length > 0) { // Not needed
      currentComparePrice.innerHTML = `${prettyComparePrice}`;
      //}
    }
  }

  // Update for the stock
  const addToCartBtn = document.querySelector('[data-add-to-cart-button]');
  const outOfStockBtn = document.querySelector('[data-out-of-stock-button]');
  const stickyAddToCartBtn = document.querySelector('#sticky-add-to-cart [data-add-to-cart-button]');
  const stickyOutOfStockBtn = document.querySelector('#sticky-add-to-cart [data-out-of-stock-button]');

  const toggleClass = (element, removeClass, addClass) => {
    if (element) {
      element.classList.remove(removeClass);
      element.classList.add(addClass);
    }
  };

  if (stock <= 0 || stock < quantity) {
    toggleClass(addToCartBtn, 'flex', 'hidden');
    toggleClass(outOfStockBtn, 'hidden', 'flex');
    toggleClass(stickyAddToCartBtn, 'flex', 'hidden');
    toggleClass(stickyOutOfStockBtn, 'hidden', 'flex');
  } else {
    toggleClass(addToCartBtn, 'hidden', 'flex');
    toggleClass(outOfStockBtn, 'flex', 'hidden');
    toggleClass(stickyAddToCartBtn, 'hidden', 'flex');
    toggleClass(stickyOutOfStockBtn, 'flex', 'hidden');
  }

  // Update the variant ID for both add to cart buttons
  var variantId = document.querySelector(`input[name="id"]`);
  var stickyVariantId = document.querySelector(`#sticky-add-to-cart input[name="id"]`);
  if (variantId) variantId.value = id;
  if (stickyVariantId) stickyVariantId.value = id;

  // Update the quantity for both add to cart buttons
  var quantityField = document.querySelector(`input[name="quantity-second"]`);
  var stickyQuantityField = document.querySelector(`#sticky-add-to-cart input[name="quantity-second"]`);
  if (quantityField) quantityField.value = quantity;
  if (stickyQuantityField) stickyQuantityField.value = quantity;

  // Update the current active image (only when variant changes, not when quantity changes)
  if (updateImage) {
    var selectedImage = document.querySelector(`input[value="${id}"]`).getAttribute('data-image');
    if (selectedImage) {
      imageWrapper.forEach((image) => {
        if (image.classList.contains('swiper-slide-active')) {
          let activeImage = image;
          let activeImageWrapper = activeImage.querySelector('img');
          activeImageWrapper.src = selectedImage;
        }
      });
    }
  }

  if (variantError.classList.contains('flex')) {
    variantError.classList.remove('flex');
    variantError.classList.add('hidden');
  }
}

window.updatePriceWithCrossselling = function updatePriceWithCrossselling() {
  const currentPrice = document.querySelector('.current-price');
  const quantity = parseInt(quantityInput?.value || 1);
  const price = currentPrice.getAttribute('data-price');
  var priceExcl = currentPrice.getAttribute('data-price');
  var totalPriceExcl = priceExcl * quantity;

  if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
    var totalPrice = price * 1.21 * quantity;
  } else {
    var totalPrice = price * quantity;
  }

  // Add cross-selling items (use a Set to prevent duplicates)
  const processedVariants = new Set();

  // Add static cross-selling items
  if (crossselling) {
    console.log('Static cross-selling items found:', crossselling.length);

    // First, collect all dynamic cross-selling variant IDs to avoid duplicates
    const dynamicVariantIds = new Set();
    const dynamicCrosssellingItems = document.querySelectorAll('.crossselling-product');
    dynamicCrosssellingItems.forEach(function (product) {
      const variantId = product.getAttribute('data-variant-id');
      if (variantId) {
        dynamicVariantIds.add(variantId);
      }
    });

    crossselling.forEach(function (product) {
      const variantId = product.getAttribute('data-variant-id');
      const checkbox = product.querySelector('input[type="checkbox"]');
      const crosssellingQuantityInput = product.querySelector('[id^="quantity-input"]');

      console.log('Processing static item:', {
        variantId,
        hasQuantityInput: !!crosssellingQuantityInput,
        quantity: crosssellingQuantityInput ? crosssellingQuantityInput.value : 'no input',
        isDynamic: dynamicVariantIds.has(variantId),
      });

      // Skip static items that have dynamic equivalents
      if (dynamicVariantIds.has(variantId)) {
        console.log('Skipping static item - has dynamic equivalent:', variantId);
        return;
      }

      //if (checkbox && checkbox.checked && crosssellingQuantityInput) {
      if (crosssellingQuantityInput && !processedVariants.has(variantId)) {
        processedVariants.add(variantId);
        const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 0);
        const crosssellingPrice = parseFloat(
          product.querySelector('[data-product-price]').getAttribute('data-product-price')
        );
        console.log('Adding static to total:', {
          quantity: crosssellingQuantity,
          price: crosssellingPrice,
          total: crosssellingPrice * crosssellingQuantity,
        });
        if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
          totalPrice += crosssellingPrice * 1.21 * crosssellingQuantity;
        } else {
          totalPrice += crosssellingPrice * crosssellingQuantity;
        }
        totalPriceExcl += crosssellingPrice * crosssellingQuantity;
      }
    });
  }

  // Add dynamic cross-selling items (variant-specific)
  const dynamicCrosssellingItems = document.querySelectorAll('.crossselling-product');
  console.log('Dynamic cross-selling items found:', dynamicCrosssellingItems.length);

  // Clear processed variants for dynamic items to allow them to override static ones
  const dynamicProcessedVariants = new Set();

  dynamicCrosssellingItems.forEach(function (product) {
    const variantId = product.getAttribute('data-variant-id');
    const crosssellingQuantityInput = product.querySelector('[id^="quantity-input"]');
    const priceElement = product.querySelector('[data-product-price]');

    console.log('Processing dynamic item:', {
      variantId,
      hasQuantityInput: !!crosssellingQuantityInput,
      hasPriceElement: !!priceElement,
      quantity: crosssellingQuantityInput ? crosssellingQuantityInput.value : 'no input',
      price: priceElement ? priceElement.getAttribute('data-product-price') : 'no price',
    });

    if (crosssellingQuantityInput && !dynamicProcessedVariants.has(variantId)) {
      dynamicProcessedVariants.add(variantId);
      const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 0);
      const crosssellingPrice = parseFloat(
        product.querySelector('[data-product-price]').getAttribute('data-product-price')
      );
      console.log('Adding dynamic to total:', {
        quantity: crosssellingQuantity,
        price: crosssellingPrice,
        total: crosssellingPrice * crosssellingQuantity,
      });
      if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
        totalPrice += crosssellingPrice * 1.21 * crosssellingQuantity;
      } else {
        totalPrice += crosssellingPrice * crosssellingQuantity;
      }
      totalPriceExcl += crosssellingPrice * crosssellingQuantity;
    } else if (crosssellingQuantityInput && dynamicProcessedVariants.has(variantId)) {
      console.log('Dynamic item already processed (same variantId):', variantId);
    }
  });

  const prettyPrice = Shopify.formatMoney(totalPrice, amount_with_comma_separator);
  if (currentPrice) {
    currentPrice.setAttribute('data-excl-price', totalPriceExcl);
    currentPrice.innerHTML = `${prettyPrice}`;
  }
};

// Helper: Get quantity of a variant in the cart
async function getVariantQuantityInCart(variantId) {
  try {
    const cart = await fetchCartItems();
    if (!cart || !cart.items) return 0;
    const item = cart.items.find((i) => i.id == variantId);
    return item ? item.quantity : 0;
  } catch (e) {
    return 0;
  }
}

// Helper: Toggle add-to-cart and out-of-stock buttons
function toggleAddToCartButtons(allowed) {
  const addToCartBtn = document.querySelector('[data-add-to-cart-button]');
  const outOfStockBtn = document.querySelector('[data-out-of-stock-button]');
  if (allowed) {
    if (addToCartBtn) {
      addToCartBtn.classList.remove('hidden');
      addToCartBtn.classList.add('flex');
    }
    if (outOfStockBtn) {
      outOfStockBtn.classList.add('hidden');
      outOfStockBtn.classList.remove('flex');
    }
  } else {
    if (addToCartBtn) {
      addToCartBtn.classList.add('hidden');
      addToCartBtn.classList.remove('flex');
    }
    if (outOfStockBtn) {
      outOfStockBtn.classList.remove('hidden');
      outOfStockBtn.classList.add('flex');
    }
  }
}

// Update quantity controls and buttons to enforce stock minus in-cart
async function enforceMaxQuantityAndButtons() {
  // Get selected variant id
  let variantId = null;
  if (typeof product.selected_or_first_available_variant !== 'undefined') {
    variantId = product.selected_or_first_available_variant.id;
  } else if (currentOptions) {
    // Try to find the variant id from currentOptions
    let option1 = currentOptions['option1'] || 'Default Title';
    let option2 = currentOptions['option2'] || '';
    let option3 = currentOptions['option3'] || '';
    let found = null;
    switch (optionsSize) {
      case 3:
        found = product.variants.find((v) => v.option1 === option1 && v.option2 === option2 && v.option3 == option3);
        break;
      case 2:
        found = product.variants.find((v) => v.option1 === option1 && v.option2 === option2);
        break;
      case 1:
        found = product.variants.find((v) => v.option1 === option1);
        break;
    }
    if (found) variantId = found.id;
  }
  if (!variantId) return;

  // Get stock for this variant
  const stock = stocksMap[variantId] || 0;
  // Get in-cart quantity
  const inCart = await getVariantQuantityInCart(variantId);
  const maxAllowed = Math.max(stock - inCart, 0);

  // Update main quantity input
  const mainInput = document.querySelector('.quantity-input');
  const mainInc = document.querySelector('.increment-button');
  const mainDec = document.querySelector('.decrement-button');

  // Clamp value and disable increment if at max
  if (mainInput) {
    let val = parseInt(mainInput.value) || 1;
    if (val > maxAllowed) mainInput.value = maxAllowed > 0 ? maxAllowed : 1;
    mainInput.max = maxAllowed;
    mainInput.disabled = maxAllowed === 0;
  }
  if (mainInc) {
    mainInc.disabled = !mainInput || parseInt(mainInput.value) >= maxAllowed;
  }
  if (mainDec) {
    mainDec.disabled = !mainInput || parseInt(mainInput.value) <= 1;
  }

  // Toggle add-to-cart and out-of-stock buttons
  toggleAddToCartButtons(maxAllowed > 0);
}

function setupQuantityControls() {
  if (!quantityInput) return;

  quantityInput.addEventListener('change', () => {
    if (currentOptions) {
      updateCurrentOptions(currentOptions, false);
    }
    // Trigger cross-sell quantity sync
    if (window.crosssellQuantitySync) {
      window.crosssellQuantitySync.manualSync();
    }
  });

  incrementButton.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value);
    quantityInput.value = currentValue + 1;
    if (currentOptions) {
      updateCurrentOptions(currentOptions, false);
    }
    // Trigger cross-sell quantity sync
    if (window.crosssellQuantitySync) {
      window.crosssellQuantitySync.manualSync();
    }
  });

  decrementButton.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value);
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
      if (currentOptions) {
        updateCurrentOptions(currentOptions, false);
      }
      // Trigger cross-sell quantity sync (debounced)
      if (window.crosssellQuantitySync) {
        setTimeout(() => {
          window.crosssellQuantitySync.manualSync();
        }, 50);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', setupQuantityControls);

function showCartNotification(shoppingcart, added) {
  const cart_notification = document.querySelectorAll('.custom-cart-notification');
  const products = shoppingcart.items;
  const added_products = added;
  const notification_products = [];

  cart_notification.forEach((cartNotification) => {
    if (cartNotification.classList.contains('hidden')) {
      cartNotification.classList.remove('hidden');
    }
  });

  if ('items' in shoppingcart) {
    products.forEach((product) => {
      var product_id = product.id;
      var title = product.product_title;

      added_products.forEach((item) => {
        var added_id = item.id;
        var added_quantity = item.quantity;
        if (product_id == added_id) {
          notification_products.push({
            quantity: added_quantity,
            title: title,
          });
        }
      });
    });

    if (notification_products.length > 0) {
      var div = document.createElement('div');
      div.className = 'bg-mediocre rounded-[3px] py-6 px-6';
      var h3 = document.createElement('h3');
      h3.className = 'mb-4 text-lg leading-normal font-bold text-highlight_light';
      h3.textContent = 'Toegevoegd!';
      var ul = document.createElement('ul');
      notification_products.forEach((item) => {
        var li = document.createElement('li');
        li.className = 'text-sm mb-2 text-highlight_dark';
        li.textContent = item.quantity + ' x ' + item.title;
        ul.appendChild(li);
      });
      var span = document.createElement('span');
      span.className = 'block bg-highlight_light text-highlight_dark font-bold text-center py-2 rounded-[3px] mt-6';
      span.textContent = 'Ga naar winkelwagen';
      div.appendChild(h3);
      div.appendChild(ul);
      div.appendChild(span);
      cart_notification.forEach((cartNotification) => {
        cartNotification.appendChild(div.cloneNode(true));
      });
    }
  } else {
    var div = document.createElement('div');
    div.className = 'bg-mediocre rounded-[3px] py-6 px-6';
    var h3 = document.createElement('h3');
    h3.className = 'mb-4 text-lg leading-normal font-bold text-highlight_light';
    h3.textContent = 'Niet toegevoegd!';
    var p = document.createElement('p');
    p.textContent = shoppingcart.message;
    var span = document.createElement('span');
    span.className = 'block bg-highlight_light text-highlight_dark font-bold text-center py-2 rounded-[3px] mt-6';
    span.textContent = 'Ga naar winkelwagen';
    div.appendChild(h3);
    div.appendChild(p);
    div.appendChild(span);
    cart_notification.forEach((cartNotification) => {
      cartNotification.appendChild(div.cloneNode(true));
    });
  }
}

function hideCartNotification() {
  const cart_notification = document.querySelectorAll('.custom-cart-notification');
  cart_notification.forEach((cartNotification) => {
    cartNotification.classList.add('hidden');
    cartNotification.innerHTML = '';
  });
}

function updateBarcode(barcode) {
  const barcode_wrapper = document.querySelector('.barcode');
  if (barcode_wrapper) {
    barcode_wrapper.innerHTML = barcode;
  }
}

// Debounce cart updates to prevent race conditions
let cartUpdateTimeout = null;
let isUpdatingCart = false;

async function updateSmallcart() {
  // Prevent multiple simultaneous cart updates
  if (isUpdatingCart) {
    console.log('Cart update already in progress, skipping...');
    return;
  }

  // Clear any pending updates
  if (cartUpdateTimeout) {
    clearTimeout(cartUpdateTimeout);
  }

  // Debounce the update
  cartUpdateTimeout = setTimeout(async () => {
    isUpdatingCart = true;
    const cart_count = document.querySelector('.cart-count p');

    try {
      console.log('Updating small cart...');

      // Fetch the latest cart data for logging
      const cart = await fetchCartItems();
      if (cart) {
        console.log('Cart count updated - unique items:', cart.items ? cart.items.length : 'unknown');
        console.log('Total cart quantity:', cart.item_count);
        console.log('Cart items:', cart.items ? cart.items.length : 'no items array');
      }

      // Fetch the updated header section and replace cart components
      const response = await fetch('/?sections=em-header');
      if (response.ok) {
        const data = await response.json();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['em-header'], 'text/html');

        // Desktop cart
        const newCartDesktop = doc.querySelector('[data-component-id="cart-component-1"]');
        const oldCartDesktop = document.querySelector('[data-component-id="cart-component-1"]');
        if (newCartDesktop && oldCartDesktop) {
          oldCartDesktop.replaceWith(newCartDesktop);
        }

        // Mobile cart
        const newCartMobile = doc.querySelector('[data-component-id="cart-component-2"]');
        const oldCartMobile = document.querySelector('[data-component-id="cart-component-2"]');
        if (newCartMobile && oldCartMobile) {
          oldCartMobile.replaceWith(newCartMobile);
        }

        // Re-initialize cart dropdown listeners
        if (window.initSmallCartDropdown) {
          window.initSmallCartDropdown();
        }

        console.log('Cart components updated successfully');
      }
    } catch (error) {
      console.error('Error updating small cart:', error);
    } finally {
      isUpdatingCart = false;
    }
  }, 100); // 100ms debounce
}

async function fetchCartItems() {
  try {
    const response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error('Something wrongs');
    }
    const cart = await response.json();

    // Don't recursively refetch - just return the cart even if empty
    // This prevents infinite loops and race conditions
    return cart;
  } catch (error) {
    console.error('Fetch error:', error);
    return null;
  }
}

function handleAddToCart(event, form, errorElement) {
  console.log('handleAddToCart called!', {
    eventType: event.type,
    target: event.target,
    currentTarget: event.currentTarget,
    form: form,
  });

  const formData = new FormData(form);
  const productId = formData.get('id');
  const productQty = formData.get('quantity-second');

  const items = [
    {
      id: parseInt(productId, 10), // Ensure product ID is a number
      quantity: parseInt(productQty, 10),
    },
  ];

  // Wait for any pending cross-sell updates to complete before collecting items
  setTimeout(() => {
    collectAndSubmitCrosssellItems(items, form, errorElement);
  }, 100); // Give time for any pending debounced updates
}

function forceCrosssellUpdatesToComplete() {
  // Force all cross-sell quantity inputs to update their values
  const allCrosssellInputs = document.querySelectorAll('[id^="quantity-input-"]');
  allCrosssellInputs.forEach((input) => {
    // Trigger a change event to ensure the value is properly set
    const event = new Event('input', { bubbles: true });
    input.dispatchEvent(event);
  });

  // Also trigger any pending cross-sell sync
  if (window.crosssellQuantitySync) {
    window.crosssellQuantitySync.manualSync();
  }

  console.log('Forced cross-sell updates to complete');
}

function collectAndSubmitCrosssellItems(items, form, errorElement) {
  // Force any pending cross-sell updates to complete
  forceCrosssellUpdatesToComplete();

  // Collect all cross-selling items (both static and dynamic)
  const allCrosssellingItems = new Map(); // Use Map to prevent duplicates

  // Add static cross-selling items
  if (crossselling) {
    crossselling.forEach(function (product) {
      const variantId = product.getAttribute('data-variant-id');
      const quantityInput = product.querySelector('[id^="quantity-input"]');
      const crossellingQty = quantityInput ? quantityInput.value : '0';
      const quantity = parseInt(crossellingQty, 10);

      console.log('Processing static item:', {
        variantId,
        hasQuantityInput: !!quantityInput,
        quantity: crossellingQty,
        parsedQuantity: quantity,
        isDynamic: false,
      });

      // Validate that we have a valid variant ID and quantity
      if (variantId && !isNaN(quantity) && quantity > 0) {
        const variantIdInt = parseInt(variantId, 10);

        // Only add if not already present (prevent duplicates)
        if (!allCrosssellingItems.has(variantIdInt)) {
          allCrosssellingItems.set(variantIdInt, quantity);
          console.log('Adding static cross-sell item:', { variantId: variantIdInt, quantity });
        }
      } else {
        console.log('Skipping static item - invalid data:', { variantId, quantity });
      }
    });
  }

  // Add dynamic cross-selling items (variant-specific)
  const dynamicCrosssellingItems = document.querySelectorAll('.crossselling-product');
  console.log('Dynamic cross-selling items found:', dynamicCrosssellingItems.length);

  dynamicCrosssellingItems.forEach(function (product) {
    const variantId = product.getAttribute('data-variant-id');
    const quantityInput = product.querySelector('[id^="quantity-input"]');
    const crossellingQty = quantityInput ? quantityInput.value : '0';
    const quantity = parseInt(crossellingQty, 10);

    console.log('Processing dynamic item:', {
      variantId,
      hasQuantityInput: !!quantityInput,
      quantity: crossellingQty,
      parsedQuantity: quantity,
      isDynamic: true,
    });

    // Validate that we have a valid variant ID and quantity
    if (variantId && !isNaN(quantity) && quantity > 0) {
      const variantIdInt = parseInt(variantId, 10);

      // Only add if not already present (prevent duplicates)
      if (!allCrosssellingItems.has(variantIdInt)) {
        allCrosssellingItems.set(variantIdInt, quantity);
        console.log('Adding dynamic cross-sell item:', { variantId: variantIdInt, quantity });
      } else {
        console.log('Dynamic item already exists, updating quantity:', {
          variantId: variantIdInt,
          oldQuantity: allCrosssellingItems.get(variantIdInt),
          newQuantity: quantity,
        });
        allCrosssellingItems.set(variantIdInt, quantity);
      }
    } else {
      console.log('Skipping dynamic item - invalid data:', { variantId, quantity });
    }
  });

  // Add all cross-selling items to the items array
  allCrosssellingItems.forEach(function (quantity, variantId) {
    items.push({
      id: variantId,
      quantity: quantity,
    });
  });

  // Log the final items being sent to cart
  console.log('Items being added to cart:', items);
  console.log('Total items count:', items.length);
  console.log('Cross-sell items count:', allCrosssellingItems.size);

  // Get the main product quantity for validation
  const formData = new FormData(form);
  const productQty = formData.get('quantity-second');

  if (!isNaN(parseInt(productQty, 10))) {
    if (errorElement.classList.contains('flex')) {
      errorElement.classList.remove('flex');
      errorElement.classList.add('hidden');
    }
    if (items && items.length > 0) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          console.log('Successfully added items to cart:', data);
          console.log('Cart now contains items:', data.items ? data.items.length : 'unknown');
          // showCartNotification(data, items); // Disabled notification

          // Delay cart update to prevent race conditions
          setTimeout(() => {
            updateSmallcart();
          }, 200);

          // setTimeout(function () {
          //   hideCartNotification();
          // }, 3000);
        })
        .catch((error) => {
          console.error('Error adding items to cart:', error);
          // You could show an error message to the user here
        });
    } else {
      console.error('No items to add to cart!');
    }
  } else {
    if (errorElement.classList.contains('hidden')) {
      errorElement.classList.remove('hidden');
      errorElement.classList.add('flex');
      // Hide error message after 3 seconds
      setTimeout(() => {
        if (errorElement.classList.contains('flex')) {
          errorElement.classList.remove('flex');
          errorElement.classList.add('hidden');
        }
      }, 3000);
    }
  }
}
